import {
  DEFAULT_SEPARATOR,
  DEFAULT_TITLE_PREFIX,
} from 'components/shared/PageTitle/constants';
import type { FunctionComponent } from 'react';
import Helmet from 'react-helmet';

export interface PageTitleProps {
  titlePrefix?: string;
  seperator?: string;
  title?: string;
}

const PageTitle: FunctionComponent<PageTitleProps> = function ({
  titlePrefix = DEFAULT_TITLE_PREFIX,
  seperator = DEFAULT_SEPARATOR,
  title = 'Quote',
}) {
  return (
    <Helmet>
      <title>
        {titlePrefix} {title && seperator} {title}
      </title>
    </Helmet>
  );
};

export default PageTitle;
